module.exports = __webpack_public_path__ + "static/media/highlight_title.c4c13123.png";